'use client'

import { v4 as uuidv4 } from 'uuid'
import { Dispatch } from 'redux'
import { savePoint } from '../_store/common/common.slice'
import { IPoint } from '../_store/common/types'
import { yandexService } from '../_service/yandex.service'

/**
 * Handler for geolocation errors
 */
const errorHandler = (err: GeolocationPositionError) => {
  if (err.code === 1) {
    console.log('Error: Access is denied!')
  } else if (err.code === 2) {
    console.log('Error: Position is unavailable!')
  } else {
    console.log(`Error(${err.code}): ${err.message}`)
  }
}

type LocationData = {
  latitude: number
  longitude: number
}

export async function getUserLocation(): Promise<LocationData | null> {
  // Fallback to browser geolocation
  if ('geolocation' in navigator) {
    console.log('went to navigator')
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log('resolved navigator', position)
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })
        },
        (error) => {
          console.log('unresolved navigator', error)
          errorHandler(error)
          reject(error)
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      )
    })
  }

  throw new Error('Geolocation is not supported in this environment.')
}

/**
 * Create a new point from coordinates using Yandex geocoding
 */
export const createPointFromCoordinates = async (geoloc: [number, number]) => {
  try {
    const res = await yandexService.getGeocode({
      geocode: geoloc.join(','),
      lang: 'ru_RU',
    })

    const newPoint: IPoint = {
      id: uuidv4(),
      location: geoloc,
      address:
        res?.data?.response?.response?.GeoObjectCollection?.featureMember?.[0]
          ?.GeoObject?.name,
      isActive: true,
      city: '',
      name: '',
    }

    return newPoint
  } catch (err) {
    console.log(err)
    return null
  }
}

/**
 * Check if a new point should be created based on current state
 */
export const shouldCreateNewPoint = (
  geoloc: [number, number],
  points: IPoint[],
  activePoint: IPoint | null
): boolean => {
  return Boolean(
    geoloc?.[0] &&
    geoloc?.[1] &&
    !points?.length &&
    (!activePoint?.address ||
      (activePoint?.location?.[0] !== geoloc?.[0] &&
        activePoint?.location?.[1] !== geoloc?.[1]))
  )
}

/**
 * Find and set active point from points array
 */
export const findActivePoint = (points: IPoint[]) => {
  if (points?.length > 0) {
    for (const point of points) {
      if (point?.isActive) return point
    }
  }

  return null
}
